// One hover tooltip for the tab's marks ([data-tip]: "<title>\n<detail>\n<detail>…"), styled as Task Replay's.
import { esc } from '../core'

function ensureTip(): HTMLElement {
  let t = document.getElementById('rpTip')
  if (!t) { t = document.createElement('div'); t.id = 'rpTip'; t.className = 'tr-tip'; document.body.appendChild(t) }
  return t
}

/** A repaint can take the hovered mark away before its mouseleave fires: hide the tip on every repaint. */
export function hideTip(): void {
  const t = document.getElementById('rpTip')
  if (t) t.style.display = 'none'
}

export function wireTips(root: HTMLElement): void {
  const tip = ensureTip()
  Array.prototype.forEach.call(root.querySelectorAll('[data-tip]'), (el: Element) => {
    const show = () => {
      const [head, ...rest] = (el.getAttribute('data-tip') || '').split('\n')
      tip.innerHTML = '<span class="tr-tip-h">' + esc(head || '') + '</span>' + rest.map((r) => '<span class="tr-tip-b">' + esc(r) + '</span>').join('')
      tip.style.display = 'block'
    }
    ;(el as HTMLElement).onmouseenter = show
    ;(el as HTMLElement).onfocus = show
    ;(el as HTMLElement).onmousemove = (e: MouseEvent) => {
      tip.style.left = Math.min(e.clientX + 14, window.innerWidth - 250) + 'px'
      tip.style.top = e.clientY + 14 + 'px'
    }
    ;(el as HTMLElement).onmouseleave = hideTip
    ;(el as HTMLElement).onblur = hideTip
  })
}
